import FacePageHeader from '@/components/layout/FacePageHeader';
import Nav from '@/components/navigation/Nav';
import PageIntro from '@/components/layout/PageIntro';
import { PageFooter, PageHeader, PageMain, PageShell } from '@/components/layout/PageShell';
import PageLoadingState from '@/components/ui/PageLoadingState';
import { useAuthStore } from '@/features/Auth/model/authStore';
import { useOrganization } from '@/features/Organization';
import { useProfileClientMchdApi } from '@/features/Profile/model/useProfileClientMchdApi';
import { useUserProfileApi } from '@/features/Profile/model/useUserProfileApi';
import ProfileView from '@features/Profile/ui/ProfileView';

const ProfilePage = () => {
  const orgId = useAuthStore((state) => state.tokenData?.org_id ?? null);

  const {
    isOrganizationLoading,
    organization
  } = useOrganization();

  const {
    data: dataGetClientMchd,
    isLoading: isLoadingGetClientMchd
  } = useProfileClientMchdApi();

  const {
    data: dataGetUserById,
    isLoading: isLoadingGetUserById
  } = useUserProfileApi();

  const isProfilePageLoading =
    isLoadingGetUserById || (Boolean(orgId) && (isOrganizationLoading || isLoadingGetClientMchd));

  return (
    <PageShell
      contentVariant="face"
      footerMode="fixed"
      headerMode="static"
    >
      <PageHeader>
        <FacePageHeader />
      </PageHeader>

      <PageMain contentClassName="flex flex-1 flex-col gap-8">
        <PageIntro title="Профиль" />
        {isProfilePageLoading ? (
          <PageLoadingState
            className="min-h-[40vh]"
            label="Загрузка профиля"
          />
        ) : (
          <ProfileView
            clientMchd={dataGetClientMchd}
            isMchdLoading={isLoadingGetClientMchd}
            isOrganizationLoading={isOrganizationLoading}
            isProfileLoading={isLoadingGetUserById}
            organization={organization}
            orgId={orgId}
            userProfile={dataGetUserById}
          />
        )}
      </PageMain>

      <PageFooter>
        <Nav />
      </PageFooter>
    </PageShell>
  );
};

export default ProfilePage;